import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import PluginDetail from "./pages/PluginDetail";
import AuthPage from "./pages/AuthPage";
import { Toaster } from "./components/ui/sonner";
import { useAuth } from "./hooks/useAuth";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen" style={{ background: '#0B0F13' }}>
        <div className="text-center">
          <div className="animate-spin w-16 h-16 border-4 border-[#00FFD1] border-t-transparent rounded-full mx-auto mb-4"></div>
          <p className="text-white text-lg">Checking authentication...</p>
        </div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/auth" />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          } />
          <Route path="/plugin/:id" element={
            <ProtectedRoute>
              <PluginDetail />
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;